import { useState, useEffect } from 'react'

/**
 * Reactive hook that tracks a CSS media query.
 * Returns `false` during SSR / initial render to avoid hydration mismatch.
 *
 * @example
 * const isMobile = useMediaQuery('(max-width: 767px)')
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(false)

  useEffect(() => {
    // Guard for SSR / environments without matchMedia
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return
    }

    const mql = window.matchMedia(query)

    // Set initial value
    setMatches(mql.matches)

    const handler = (event: MediaQueryListEvent) => {
      setMatches(event.matches)
    }

    mql.addEventListener('change', handler)
    return () => mql.removeEventListener('change', handler)
  }, [query])

  return matches
}
